import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ErrorStateProps {
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ message = "Algo deu errado", onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center" role="alert">
      <AlertCircle className="h-10 w-10 text-destructive/70 mb-3" />
      <h3 className="text-sm font-medium">{message}</h3>
      <p className="text-xs text-muted-foreground mt-1">Tente novamente ou entre em contato com o suporte.</p>
      {onRetry && <Button size="sm" variant="outline" className="mt-4" onClick={onRetry}>Tentar novamente</Button>}
    </div>
  );
}
